// Performance constants from old RoomChat
export const MAX_MESSAGES_DISPLAY = 100
export const CHAT_POLL_INTERVAL = 2000
export const DEBOUNCE_DELAY = 100

// UI Configuration
export const SIDEBAR_WIDTH = 280
export const CHAT_HEIGHT = 640
export const CHAT_WIDTH = 900
export const AVATAR_SIZE_SMALL = 20
export const AVATAR_SIZE_MEDIUM = 28
export const AVATAR_SIZE_DEFAULT = 36
export const MAX_UNREAD_BADGE = 99

// Timing
export const ACTIVITY_HEARTBEAT_INTERVAL = 30000
export const ONLINE_STATUS_POLL_INTERVAL = 60000
export const INPUT_FOCUS_DELAY = 100

// Keys to block from reaching the game
export const BLOCKED_GAME_KEYS = [
  'w', 'a', 's', 'd', 'e', 'r', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', ' ', 'Tab'
] 